<template>
  <main class="modal-toggle">
    <section class="modal_wrapper" :class="{ 'modal_wrapper--workerMode': !isUserMode }">
      <header>
        <div class="toggle" v-if="canToggle && !idToEdit">
          <p @click="isUserMode = true" :class="{ 'p--active': isUserMode }">СЛУЖИТЕЛ ВАС</p>

          <div class="switch-container switch-container--reversed">
            <label class="switch">
              <input type="checkbox" v-model="isUserMode">
              <span class="slider"></span>
            </label>
          </div>

          <p @click="isUserMode = false" :class="{ 'p--active': !isUserMode }">ФИРМА ПОДИЗПЪЛНИТЕЛ</p>
        </div>
        <div v-else></div>

        <span class="tms" @click="closeModal(false)">F</span>

      </header>


      <div class="modal_view">
        <transition :name="isUserMode ? 'slide-left-and-fade' : 'slide-right-and-fade'" mode="out-in">
          <UserModal v-if="isUserMode" :limitedFunctionality="limitedFunctionality" :idToEdit="idToEdit"
            @closeUserModal="closeModal($event)" />
          <WorkerModal v-else :idToEdit="idToEdit" @closeWorkerModal="closeModal($event)" />
        </transition>
      </div>

    </section>

  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import UserModal from './UserModal';
import WorkerModal from './WorkerModal';
import log from '../mixins/log.js';
export default {
  mixins: [log],
  props: ['userMode', 'limitedFunctionality', 'idToEdit', 'canToggle'],
  components: {
    UserModal,
    WorkerModal,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ]),
    filteredGroups() {
      return this.groups.filter(g => {
        return g.name.toLowerCase().includes(this.searchGroups.toLowerCase());
      });
    }
  },
  data() {
    return {
      isUserMode: true
    };
  },
  methods: {
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$parent.$emit('closeUserToggleModal', { isEdited: isEdited });
    }
  },
  mounted() {
    this.isUserMode = this.userMode
    document.body.classList.add("no-scroll");

    this.$eventBus.$on('closeModalFromSpeechRecognition', () => {
      this.closeModal();
    });
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
    this.$eventBus.$off('closeModalFromSpeechRecognition');
  }
};
</script>

<style >
.modal-toggle {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}

.modal_wrapper {
  box-shadow: 0px 0px 50px #00000063;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  /* overflow: auto; */
  overflow: hidden;
  width: 960px;
}

.modal_wrapper .modal_view {
  padding: 0 40px;
  background: #F4F7FD;
  /* max-height: 90vh; */
  overflow: auto;
}

.user-modal {
  display: flex;
  flex-direction: column;
}
.user-modal .row {
  display: flex;
  gap: 30px;
  margin: 10px 0;
  justify-content: space-between;
}
.user-modal .row .row-field{
  position: relative;
  width: 100%;
}
.user-modal hr {
margin: 20px 0 0 0;
opacity: 0.2;
background-color: #707070;
border: 1px solid #707070;
}
.user-modal-permissions {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #cecece;
  display: flex;
  gap: 15px;
  padding: 10px 0;
  justify-content: center;
}
.user-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}

.user-modal .add-wrapper {
  align-items: center;
  color: #0450BB;
  cursor: pointer;
  display: flex;
  gap: 5px;
  width: fit-content;
}

.user-modal .add-wrapper p {
  color: #0450BB;
  font-size: 14px;
  text-decoration: underline;
}

.user-modal .add-wrapper .tms {
  color: #003580;
  font-size: 20px;
}

.user-modal  .input-label {
  color: #000000;
  font-size: 13px;
}

.user-modal .center-text {
  font-size: 13px;
  text-align: center;
}

.user-modal .group-inputs-wrapper {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow: auto;
  gap: 5px;

}
.user-modal .group-inputs-wrapper .delete {
  color: #9f0510;
  cursor: pointer;
}

.user-modal .row-inputs {
  align-items: center;
  display: flex;
  gap: 5px;
}

.user-modal .row-inputs .input-wrapper {
  width: 50%;
}

.user-modal .row-inputs .input-wrapper:nth-of-type(1) {
  width: 35%;
}

.user-modal .row-inputs .input-wrapper:nth-of-type(2) {
  width: 30%;
}

.user-modal .row .row-field {
  width: 100%;
}

.invalid .tms {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}

.modal-toggle .modal_wrapper.modal_wrapper--workerMode header {
  background: #6A4507;
}

.modal-toggle .modal_wrapper.modal_wrapper--workerMode .modal_view {
  background: #FDFAF4;
}

.modal-toggle .modal_wrapper header {
  align-items: center;
  background: #00408A;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  padding: 15px 15px 15px 40px;
  width: 100%;
}

.modal-toggle .modal_wrapper header .tms {
  cursor: pointer;
  font-size: 23px;
}

.modal-toggle .modal_wrapper header .switch-container .switch {
  margin: 0;
}

.modal-toggle .modal_wrapper .new-input-dropdown {
  transform: scaleY(0);
  transform-origin: top;
  max-height: 200px;
}
.modal-toggle .modal_wrapper .new-input-dropdown-active {
  top: 95%;
  transform: scaleY(1);
  height: initial;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal_wrapper {
    width: 90%;
  }
.user-modal-permissions {
  flex-direction: column;
}
  .user-modal .row {
  flex-direction: column;
  gap: 5px;
}
}

@media screen and (max-width: 500px) {
.user-modal-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.user-modal .group-inputs-wrapper .row-inputs {
flex-direction: column;
}
.user-modal .row-inputs .input-wrapper {
  width: 100% !important;
}

.modal_wrapper header .toggle{
  flex-direction: column;
  font-size: 13px;
}

.user-modal-actions .switch-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
}

.btns {
  justify-content: center;
}
}

@media screen and (max-height: 550px) {
.user-modal {
  height: 100%;
}

}
</style>
